import { Injectable } from '@angular/core';
import { MatPaginatorIntl } from '@angular/material/paginator';
import { TranslateService } from '@ngx-translate/core';
import { Subscription } from 'rxjs';

@Injectable()
export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  private langChangeSub?: Subscription;

  constructor(private translate: TranslateService) {
    super();
    this.applyLabels();
    this.langChangeSub = this.translate.onLangChange.subscribe(() => this.applyLabels());
  }

  private applyLabels(): void {
    this.firstPageLabel = '';
    this.previousPageLabel = '';
    this.nextPageLabel = '';
    this.lastPageLabel = '';
    this.getRangeLabel = this.buildRangeLabel.bind(this);

    this.translate.get('PAGINATOR.ITEMS_PER_PAGE').subscribe(label => {
      this.itemsPerPageLabel = label;
      this.changes.next();
    });
  }

  private buildRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return this.translate.instant('PAGINATOR.RANGE_EMPTY', { length });
    }
    const safeLength = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex =
      startIndex < safeLength ? Math.min(startIndex + pageSize, safeLength) : startIndex + pageSize;
    return this.translate.instant('PAGINATOR.RANGE', {
      start: startIndex + 1,
      end: endIndex,
      length: safeLength,
    });
  }
}
